/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import NotifyWrapper from '@/components/NotifyWrapper';

export default function extend(_Vue) {
  function generate() {
    const NotifyComponent = _Vue.extend(NotifyWrapper);
    const $component = new NotifyComponent({
      data() {
        return {
          // options,
          show: true
        };
      },
      methods: {
        dismissed() {
          this.show = false;
          $component.$el.remove();
        },
        setOptions(options) {
          this.options = options;
        }
      }
    });
    return $component;
  }

  function notify(vm, $component) {
    if (!vm.$root.$el) {
      throw new Error('root element not initialized');
    }

    $component.$mount();
    vm.$root.$el.appendChild($component.$el);
  }

  class Notify {
    constructor(vm) {
      this._vm = vm;
    }

    /**
     * 保存成功
     * @param {Number} [dismissCountDown=2] 倒數時間 (sec)
     */
    saveSuccess(dismissCountDown = 2) {
      const $component = generate();
      $component.setOptions({ type: 'success', title: $component.$t('saveSuccess'), dismissCountDown });
      notify(this._vm, $component);
    }

    /**
     * 保存失敗
     * @param {Number} [dismissCountDown=2] 倒數時間 (sec)
     */
    saveFailed(dismissCountDown = 2) {
      const $component = generate();
      $component.setOptions({ type: 'danger', title: $component.$t('saveFailed'), dismissCountDown });
      notify(this._vm, $component);
    }

    /**
     * 刪除成功
     * @param {Number} [dismissCountDown=2] 倒數時間 (sec)
     */
    deleteSuccess(dismissCountDown = 2) {
      const $component = generate();
      $component.setOptions({ type: 'success', title: $component.$t('deleteSuccess'), dismissCountDown });
      notify(this._vm, $component);
    }

    /**
     * 刪除失敗
     * @param {Number} [dismissCountDown=2] 倒數時間 (sec)
     */
    deleteFailed(dismissCountDown = 2) {
      const $component = generate();
      $component.setOptions({ type: 'danger', title: $component.$t('deleteFailed'), dismissCountDown });
      notify(this._vm, $component);
    }

    /**
     * 成功
     * @param {String} title                標題
     * @param {Number} [dismissCountDown=2] 倒數時間 (sec)
     */
    success(title, dismissCountDown = 2) {
      const $component = generate();
      $component.setOptions({ type: 'success', title, dismissCountDown });
      notify(this._vm, $component);
    }

    /**
     * 警告
     * @param {String} title                標題
     * @param {Number} [dismissCountDown=2] 倒數時間 (sec)
     */
    danger(title, dismissCountDown = 2) {
      const $component = generate();
      $component.setOptions({ type: 'danger', title, dismissCountDown });
      notify(this._vm, $component);
    }

    /**
     * 建立
     * @param {Object} options                      選項
     * @param {String} options.title                標題
     * @param {String} [options.desc]               敘述
     * @param {Number} [options.dismissCountDown=1] 倒數時間 (sec)
     * @param {String} [options.type=success]       類型 (success|danger|warning|info|light|dark)
     */
    create(options) {
      const $component = generate();
      $component.setOptions(options);
      notify(this._vm, $component);
    }
  }

  Object.defineProperty(_Vue.prototype, '$notify', {
    get() {
      return new Notify(this);
    }
  });
}
